import {AuthorContent} from "../../../src/types/author";

export const authorsInfo: Record<string, AuthorContent> = {
    adam_elwood: {
        bio: "Adam is a Machine Learning scientist. He is leading our dynamic pricing research team.",
        role: "ML Scientist",
        active: false
    },
    alberto_crespi: {
      bio: "Alberto is a Data Architect 🏛️ at lastminute.com, having joined the Data and Analytics Team in 2020. He is focused on Data-Driven approach 📊, AI🤖 and new technology in the modern data stack.",
      role: "Data Architect",
      active: true
    },
    antonino_gitto: {
        bio: 'Antonino is an experienced mobile developer specializing in building high-quality, scalable apps. Passionate about innovation, he excels in creating seamless user experiences and solving complex challenges in mobile development.',
        role: "Software Engineer",
        active: true
    },
    armando_pannella: {
        bio: 'Armando Pannella is the Data & Analytics manager within the technology department. He began his journey at lm group several years ago, starting as datawarehouse manager and witnessing technological changes that led to the current Data approach and infrastructure.',
        role: 'Data Analytics manager',
        active: false
    },
    alejandro_weichandt: {
        bio: "Alejandro is an IT professional with over 20 years of experience. He has worked extensively as a Software Engineer, specialising in mobile development. His expertise spans Java/Kotlin, Objective-C/Swift, JavaScript/TypeScript, and software engineering best practices. Alejandro currently contributes as a Software Engineer on our App team.",
        role: "Software Engineer",
        active: true
    },
    alessandro_gazzoni: {
        bio: "Alessandro is our Head of Platform Engineering. His primary responsibility lies in overseeing the strategic direction and execution of the Platform Engineering area.",
        role: "Head of Platform Engineering",
        active: true
    },
    alessandro_romano: {
        bio: "Alessandro is an Engineering Manager with 15+ years of experience, 4 of which in lastminute.com group.",
        role: "Engineering Manager",
        active: false
    },
    alessandro_rozza: {
        bio: "Alessandro is the Chief Research Officer and the Chief ML Scientist at lastminute.com group. He is managing various teams, including Strategic Analytics.",
        role: "Chief Research Officer",
        active: true
    },
    alex_stabile: {
        bio: "Alexis a senior software engineer with 10+ years of experience. He has a strong knowledge of backend (using a lot of different languages) and frontend (web and mobile) development.",
        role: "Software Engineer",
        active: true
    },
    alvaro_garcia_real: {
        bio: "Alvaro is a Software Quality Assurance Engineer. He works in our QA team to ensure our products are well tested.",
        role: "Software Quality Assurance Engineer",
        active: true
    },
    andrea_bergia: {
        bio: "Andrea is a principal software engineer with 10+ years of experience. He is a fullstack developer with strong architectural knowledge.",
        role: "Software Engineer",
        active: false
    },
    angelo_sciarra: {
        bio: "Angelo is a Software Engineer with over 15 years of experience, with a strong passion for agile practices and functional programming.",
        role: "Software Engineer",
        active: false
    },
    aurelio_gamero: {
        bio: "Bachelor of Fine Arts, sculpture lover, Frontend Developer and Graphic Designer in another life.",
        role: "Software Engineer",
        active: false
    },
    christian_speer: {
        bio: "Christian joined lastminute.com in 2017, as an Engineering Manager and now leads a big team of engineers across different countries. Passionate about web technology, he has +20 years of experience in the field.",
        role: " Engineering Manager",
        active: true
    },
    corrado_casto: {
        bio: "Corrado is the Operations Director at lastminute.com, with nearly two decades of tenure overseeing Tech and Product development. Having been part of the Group since its inception, Corrado has an in-depth understanding of both the company and the industry. He began his career as a Software Engineer and has steadily advanced to his current role, currently sitting in the Group's Leadership Team.",
        role: "Operations Director",
        active: true
    },
    cristina_noval: {
        bio: "Cristina is a Software Quality Assurance Tester with over 10 years of experience. She is passionate about testing and continually seeks to deepen her knowledge, particularly in automation.",
        role: "Software Quality Assurance Engineer",
        active: true
    },
    daniela_pavesi: {
        bio: "Daniela is an experienced Product Manager, responsible for the product evolution of the My Area and post-sales services.",
        role: "Product Manager",
        active: true
    },
    emanuele_colombo: {
        bio: "Emanuele is a Senior Software Engineer with a strong background in telecommunication networks. He is passionate about pragmatic Functional Programming and is particularly interested in tackling challenges like scaling software development and managing complexity through tools such as Domain-Driven Design (DDD), modularisation, clean code, and CI/CD.",
        role: "Software Engineer",
        active: true
    },
    fabio_fiorella: {
        bio: "Fabio has over a decade of software engineering experience building and designing scalable applications and high-traffic distributed systems.",
        role: "Software Engineer",
        active: true
    },
    fabrizio_duroni: {
        bio: "Fabrizio is a Software Developer with 15+ years of experience. He specialised in mobile application development, computer graphics and web development. He ❤️ computers 💻, music 🎸, tattoo, videogames 👾 and drawing ✏️. He is also the maintainer of this blog 👷‍.",
        role: "Software Engineer",
        active: true
    },
    fabrizio_giovannetti: {
        bio: "Fabrizio is a principal Software Engineer with 20+ years of experience. He works on the back-office website used by operators to manage reservations, the order management system, and the web services exposed to our meta search partners for flight searches.",
        role: "Principal Software Engineer",
        active: true
    },
    felice_giovinazzo: {
        bio: "Felice is an IT professional with over 15 years of experience. He began as an Android developer and later expanded his frontend and backend skills. He currently works as a Software Engineer in the Service Management Area, focusing on customer care. His expertise includes Java/Kotlin, JavaScript/TypeScript, and software engineering practices. Outside work, Felice is a ❤️ loving dad and husband, an aspiring artist🧑‍🎨, and a dedicated callisthenics athlete🏋️.",
        role: "Software Engineer",
        active: true
    },
    francesco_bonfadelli: {
        bio: "Francesco is a Software Engineer with 15+ years of experience. He specialises in mobile application development and backend development.",
        role: "Software Engineer",
        active: true
    },
    francesco_gualazzi: {
        bio: "Francesco is a Senior Software Engineer and technology enthusiast, driven by the challenge of building powerful, resilient systems that support smarter and more useful applications.",
        role: "Site reliability engineering",
        active: false
    },
    giancarlo_di_paolantonio: {
        bio: "Giancarlo is one of our principal Software Engineers. He is also an internal trainer for High-Quality Software, TDD, Refactoring Legacy Code and one of the co-founders of the Ticino Software Craft Meetup.",
        role: "Principal Software Engineer",
        active: true
    },
    giordano_tamburrelli: {
        bio: "Giordano is an Engineering Manager with a keen product mindset. He focuses on continuously optimising the equation Product = Customer x Business x Technology.",
        role: "Engineering Manager",
        active: false
    },
    giulia_luppi: {
        bio: "Giulia is an experienced Service Manager in Information Technology, reporting directly to the Platform Engineer Area Director. An ITIL® 4 Certified specialist, she excels at navigating dynamic business requirements and challenging environments.",
        role: "ITSM Manager",
        active: true
    },
    giuseppe_pinto: {
        bio: "Giuseppe is a Product Engineer with 10+ years of experience. He specialises in object-oriented programming, particularly in JAVA, with a strong focus on enhancing performance and scalability. He's currently working in the transportation supply domain.",
        role: "Software Engineer",
        active: true
    },
    ivan_delloro: {
        bio: "Ivan is a Product Engineer with 8+ years of experience. He is currently working in the Flight Supply Domain.",
        role: "Software Engineer",
        active: false
    },
    javier_lopez: {
        bio: "Javier is a Software Engineer with +15 years of experience. He is currently working with our software architects team on the evolution of our platforms.",
        role: "Software Architect",
        active: false
    },
    juan_ara: {
        bio: "Juan is an experienced technological change leader. He helps companies to find the appropriate solutions to improve their processes, helping and mentoring teams to set everyone for success.",
        role: "Software Architect",
        active: false
    },
    lorenzo_girardi: {
        bio: "Lorenzo is responsible for the Data Center, Middleware Monitoring and Enterprise Services at lastminute.com.",
        role: "Platform Architect",
        active: false
    },
    luca_gazzola: {
        bio: "Luca is a Software Engineer with a proven track record in software testing automation.",
        role: "Software Engineer",
        active: true
    },
    luca_mor: {
        bio: "Luca is an experienced Software Development Team Lead with 25+ years of experience in the internet industry. He is skilled in Java, Kotlin, Agile Practices and Methodologies.",
        role: "Engineering Manager",
        active: true
    },
    luigi_noto: {
        bio: "Luigi is a Software Engineer with over 20 years of experience. At lastminute.com, he primarily writes code in Java and Kotlin while also pursuing his passion for software architecture and DevOps practices.",
        role: "Software Engineer",
        active: true
    },
    lukasz_wroblewski: {
        bio: "Lukasz is passionate Software Developer, mainly directed in Frontend technologies. He likes to code also in C++, INO/embedded stuff, or create his own electronic devices in his free time.",
        role: "Software Engineer",
        active: false
    },
    manuel_mandatori: {
        bio: "Manuel is an experienced Full Stack Engineer with a demonstrated history of working in the IT industry. Very keen on applying clean code and refactoring techniques.",
        role: "Software Engineer",
        active: false
    },
    manuel_ranieri: {
        bio: "Manuel is a SRE 20+ years of experience. He likes to play with Linux in lots of flavors, with a preference for Debian.",
        role: "Site reliability engineering",
        active: false
    },
    marco_de_lucchi: {
        bio: "Marco is a Mobile Software Developer at lastminute.com, having joined the App Team in 2019. He is passionate about Apple and iOS development 📱, always focused on creating exceptional user experiences. Fun fact: you can quiz him about SwiftUI or Taylor Swift!",
        role: "Software Engineer",
        active: true
    },
    mariano_patafio: {
        bio: "Mariano is a Software Engineer with 15+ years of experience. He is specialized in mobile 📱 apps development. He loves everything related to Apple 🍎.",
        role: "Software Engineer",
        active: false
    },
    massimiliano_mazzarolo: {
        bio: "Massimiliano is our Chief Architect. Despite 25 years of experience he’s still obsessed with software architecture and development. He lives in Milan (Italy).",
        role: "Director of Supply Area",
        active: true
    },
    massimo_vailati: {
        bio: "Massimo Vailati is leading our SREs teams as Senior DevOps Engineer Manager. He is contributing to process adjustments, scalability enhancements, and the adoption of new technologies, fostering a closer collaboration between SREs teams and among all the key stakeholders.",
        role: "Engineering Manager",
        active: true
    },
    matteo_orru: {
        bio: "Matteo is Software engineering research scientist with a background on software metrics, static analysis, complex networks analysis, refactoring, anomaly detection, monitoring and testing.",
        role: "Software Quality Assurance Engineer",
        active: true
    },
    mauro_ferratello: {
        bio: "Mauro is an Agile DevOps Engineer with a big experience in web development, and he is geek just a little bit. He is Full Automation evangelist, DRY obsessed, KISS fan.",
        role: "Site reliability engineering",
        active: false
    },
    michele_gasperi: {
        bio: "Michele is one of our IT Service Management Specialist. He is in charge of coordinate and manage processes for incidents and problems.",
        role: "ITSM Specialist",
        active: true
    },
    mike_lines: {
        bio: "Mike is heading our Tech Team in Poland (DevOps, CloudOps, Frontend, Backend, Full Stack, and QA). He’s focused on developing our new cutting-edge Content & Social Media Hub.",
        role: "Chief Technical Office (Poland)",
        active: true
    },
    niranjani_s_b: {
        bio: "Niranjani is an Application Developer from Thoughtworks with 6 years of experience in full-stack development and cloud technologies. She works as a software consultant in the static hotel supply domain.",
        role: "Software Engineer",
        active: false
    },
    omar_shatani: {
        bio: "Omar is a member of the App team, with 5+ years of IT experience and a special focus on mobile development using React Native. He specialises in JavaScript/TypeScript and Kotlin, and has a strong foundation in software engineering practices.",
        role: "software engineer",
        active: false
    },
    otto_abreu: {
        bio: "Otto is one of our Software Architects with 20+ years of experience. His main areas of activity are AWS cloud, automation and APIs. He’s currently working in the Core Architecture team.",
        role: "Software Architect",
        active: true
    },
    paolo_banfi: {
        bio: "Paolo is one of our Software Architects and an accomplished Software Engineer specialising in Object-Oriented Design and Analysis. He is an experienced software craftsman with expertise in Agile practices, Test-Driven Development, SOLID principles, Domain-Driven Design, and event-storming techniques. Additionally, Paolo has extensive teaching experience, offering private courses on TDD, SOLID principles, clean code, and microdesign.",
        role: "Software Architect",
        active: true
    },
    paolo_vitali: {
        bio: "Paolo takes care of the overall implementation of SRE principles in company's whole infrastructure through automation. He is architecting solutions for scalability and reliability of on-premises, hybrid and multi-cloud environments.",
        role: "Site reliability engineering",
        active: false
    },
    paweł_suchy: {
        bio: "Paweł is a developer with 15+ years of experience. He is currently working as a Backend Developer on one of our Digital Experience Platforms.",
        role: "Software Engineer",
        active: true
    },
    pratap_kambaladinne: {
        bio: "Pratap is a Software Quality Assurance Engineer working in our QA team.",
        role: "Software Quality Assurance Engineer",
        active: true
    },
    rabbani_kajamohideen: {
        bio: "Rabbani is a Software Architect with 20+ years of experience. He specialises in Solution and Enterprise Architecture. Currently, he is leading the Core Architecture team, which is responsible for tech and enterprise initiatives in our technology function.",
        role: "Software Architect",
        active: true
    },
    raffaella_rossini: {
        bio: "Raffaella is the Head of Employee Experience at lastminute.com, where she crafts an employee experience designed to foster engagement in the workplace, thus supporting productivity, innovation, and customer satisfaction while enhancing personal happiness and well-being.",
        role: "Head of Employee Experience",
        active: true
    },
    sam_campisi: {
        bio: "Sam is a Software Engineer with a focus on front-end development, specializing in building and enhancing web and mobile applications using React Native. Passionate about delivering exceptional user experiences (UX), she is driven by a desire to create usable and intuitive interfaces.",
        role: "Software Engineer",
        active: true
    },
    stefano_varesi: {
        bio: "Stefano is a passionate Senior Software Engineer with over 10 years of experience, specialising in programming.",
        role: "Software Engineer",
        active: false
    },
    thiago_nascimento_figueiredo: {
        bio: "Thiago is an IT professional with over 20 years of experience. He has worked as a Software Engineer, Software Architect, and Solutions Architect, and currently serves as a Software Engineer in a Product Engineering team. His main areas of expertise include Java/Kotlin, JEE, Spring, CI/CD, modelling, and software engineering practices.",
        role: "Software Engineer",
        active: true
    },
    tiziano_antico: {
        bio: "Tiziano is a product engineer with 6 years of experience currently working in the static hotel supply domain.",
        role: "Software Engineer",
        active: true
    },
    tommaso_resti: {
        bio: "Tommaso is experienced Senior Software Engineer. He originally worked in Embedded Software Engineering, transitioned to Mobile Development, and lastly as Backend and Frontend (FullStack).",
        role: "Software Engineer",
        active: false
    },
    valerio_vaudi: {
        bio: "Valerio is Software Developer with 10+ years of experience. He is a Spring Source Ecosystem expert, AWS Certified, DevOps, and Distributed Systems enthusiast.",
        role: "Software Engineer",
        active: false
    },
    staff: {
        bio: "We are the European Travel Tech leaders in Dynamic Holiday Packages. We leverage our Technology to simplify, personalise, and enhance customers’ travel experience.",
        role: "",
        active: true
    }
}
